module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-sm-12 mb-4"
  }, [_c('div', {
    staticClass: "row pt-4"
  }, [_c('div', {
    staticClass: "d-flex col-md-6"
  }, [_c('div', {
    staticClass: "d-flex w-100"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "glued-right bg-lighter w-100",
    attrs: {
      "type": "text",
      "placeholder": "Search agent name"
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end col-md-6"
  }, [_c('export', {
    attrs: {
      "exportOptions": _vm.exportOptions
    }
  })], 1)])]), _vm._v(" "), (_vm.getIsLoadingAssociatedAgent) ? _c('div', {
    staticClass: "mt-4 p-4 text-center"
  }, [_c('loader')], 1) : _c('div', [_c('list', {
    attrs: {
      "header": _vm.header,
      "body": _vm.body,
      "rows": _vm.filteredAgents,
      "actions": _vm.actions
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "glued-left dark"
  }, [_c('i', {
    staticClass: "ico-search larger color-1"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-3a730012", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a730012"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/people/PeopleAgents.vue
// module id = 2962
// module chunks = 0